import styled, { css } from "styled-components";
import { theme } from "../../../theme/GlobalTheme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin: 0 auto;
  width: 100%;
  max-width: 600px;
  min-height: auto;
  padding: ${theme.spacing.lg} ${theme.spacing.xl};
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 500px;
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.primary};
  border-radius: ${theme.borderRadius.large};
  padding: ${theme.spacing.xl};
  box-shadow: ${theme.shadows.card};
`;

export const Title = styled.h3`
  font-size: ${theme.typography.fontSize.h3};
  color: ${theme.colors.primary};
  margin-bottom: ${theme.spacing.lg};
  text-align: center;
  font-weight: ${theme.typography.fontWeight.bold};
`;

// Shared styles for form inputs
const baseInputStyles = css`
  border: 1px solid ${theme.colors.primary};
  border-radius: ${theme.borderRadius.large};
  padding: ${theme.spacing.md};
  font-size: ${theme.typography.fontSize.body};
  font-family: ${theme.typography.fontFamily};
  width: 100%;
  background-color: ${theme.colors.white};
  color: ${theme.colors.text};
  box-sizing: border-box;
  
  &:focus {
    outline: none;
    border-color: ${theme.colors.secondary};
    box-shadow: 0px 0px 0px 2px rgba(194, 42, 144, 0.1);
  }
`;

export const Input = styled.input`
  ${baseInputStyles}
  margin-bottom: ${theme.spacing.md};
`;

export const Button = styled.button`
  border: none;
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  width: 100%;
  text-align: center;
  padding: 15px;
  font-size: ${theme.typography.fontSize.body};
  font-family: ${theme.typography.fontFamily};
  font-weight: ${theme.typography.fontWeight.bold};
  border-radius: ${theme.borderRadius.medium};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  margin-top: ${theme.spacing.lg};

  &:hover {
    background-color: ${theme.colors.secondary};
    transform: translateY(-1px);
    box-shadow: ${theme.shadows.light};
  }

  &:active {
    transform: translateY(0);
  }
`;

export const Label = styled.label`
  font-size: ${theme.typography.fontSize.body};
  color: ${theme.colors.textDark};
  margin-bottom: ${theme.spacing.sm};
  display: block;
  font-weight: ${theme.typography.fontWeight.bold};
  font-family: ${theme.typography.fontFamily};
`;

export const DropdownContainer = styled.div`
  margin-bottom: 0;
  
  &:not(:last-of-type) {
    margin-bottom: ${theme.spacing.md};
  }
`;

export const Dropdown = styled.select`
  ${baseInputStyles}
  -webkit-appearance: none;
  margin-bottom: 0;
  cursor: pointer;
`;

export const ValidationError = styled.div`
  color: ${theme.colors.error};
  font-size: ${theme.typography.fontSize.small};
  margin-bottom: ${theme.spacing.sm};
  font-family: ${theme.typography.fontFamily};
`;